import {
    VisionCameraStatus,
    VisionCameraStatusDeprecated,
} from "@volley/shared/coach-models";
import {
    VisionLocalizationStatus,
    VisionLocalizationStatusDeprecated,
} from "@volley/shared/vision-models";

export function isDeprecatedCameraStatus(
    status: VisionCameraStatus | undefined,
): status is VisionCameraStatusDeprecated {
    return status !== undefined && !("orientationCurrentSource" in status);
}

export function isDeprecatedLocalizationStatus(
    status: VisionLocalizationStatus | undefined,
): status is VisionLocalizationStatusDeprecated {
    return status !== undefined && !("accurate" in status);
}
